module.exports = __webpack_public_path__ + "img/kei_new.a20ef967.gif";